import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Typography, Radio, TextField } from '@material-ui/core';
import { ZipCodeMask } from 'components/maskedInputs';
import { StripeElementWrapper } from '../StripeElementWrapper';
import { CardNumberElement, CardExpiryElement, CardCVCElement } from 'react-stripe-elements';
import BasicInfo from './BasicInfo';

const useStyles = makeStyles(({ palette }) => ({
  root: {},
  optionsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  option: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: 16,
    paddingRight: 16,
    marginTop: 16,
    paddingBottom: 32
  },
  ccInfo: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  selectedOption: {
    backgroundColor: palette.primary.main,
    color: palette.primary.contrastText
  },
  recommended: {
    position: 'absolute',
    bottom: 0
  }
}));




const membershipTypes = [
  { label: 'Free', value: 'free', price: '0' },
  { label: 'Trial', value: 'trial', price: '7', recommended: true },
  { label: 'Full Access', value: 'full', price: '20' }
];
const Membership = ({ membershipType, onMembershipChanged, onChanged, creds }) => {
  const classes = useStyles({});
  const [plans, setPlans] = useState();
  const [products, setProducts] = useState();
  useEffect(() => {
    const FetchPlan = async () => {
      const res = await fetch('https://api.stripe.com/v1/plans', {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer sk_test_MYEbvmTwBrdJpr9f3J46KbpV00gO6wNMYW',
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setPlans(data.data);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    };
    const FetchProduct = async () => {
      const res = await fetch('https://api.stripe.com/v1/products', {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer sk_test_MYEbvmTwBrdJpr9f3J46KbpV00gO6wNMYW',
          'Content-Type': 'application/json',
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setProducts(data.data);
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
    FetchPlan();
    FetchProduct();
  }, [])
  return (
    <div className={classes.root}>
      <div className={classes.optionsContainer}>
        {plans && plans.map((plan) => {
          return (
            <div key={plan.id} className={classes.option}>
              {products && products.map((product) => {
                if (product.id == plan.product) {
                  const planName = product.name;
                  const recommended = planName == 'Trial' ? true : false
                  const value = planName == 'Trial' ? 'trial' : planName == 'Free' ? 'free'
                    : planName == 'Full Access' ? 'full' : ''
                  return (
                    <div key={product.id}>
                      {recommended && (
                        <Typography variant="caption" className={classes.recommended}>
                          <strong>Recommended</strong>
                        </Typography>
                      )}
                      <Typography variant="h6">${plan.amount == 0 ? '0.00' : (plan.amount / 100).toFixed(2)}</Typography>
                      <Typography variant="subtitle2">{planName}</Typography>
                      <Radio
                        checked={membershipType == value ? true : false}
                        onChange={e => onMembershipChanged('membershipType', e.target.value, plan.id, product.name)}
                        value={value}
                        inputProps={{ 'aria-label': { value } }}
                      />
                    </div>
                  );
                }
              })}
            </div>
          )
        })
        }
      </div>

      {/* <div className={classes.optionsContainer}>
        {membershipTypes.map(({ label, value, price, recommended }) => (
          <div key={value} className={classes.option}>
            {recommended && (
              <Typography variant="caption" className={classes.recommended}>
                <strong>Recommended</strong>
              </Typography>
            )}

            <Typography variant="h6">${price}</Typography>
            <Typography variant="subtitle2">{label}</Typography>
            <Radio
              checked={membershipType === value}
              onChange={e => onMembershipChanged('membershipType', e.target.value)}
              value={value}
              inputProps={{ 'aria-label': label }}
            />
          </div>
        ))}
      </div> */}
      {membershipType == 'free' ?
        <div></div>
        : <div>
          <TextField
            label="Cardholder Name"
            required
            autoFocus
            fullWidth
            onChange={e => onMembershipChanged('name', e.target.value, null, null)}
            autoComplete="cc-name"
            margin="normal"
          />
          <StripeElementWrapper label="Card Number" id="cardNumbner" component={CardNumberElement} />
          <StripeElementWrapper label="Expiry (MM / YY)" id="expDate" component={CardExpiryElement} />
          <StripeElementWrapper label="CVC" id="cvv" component={CardCVCElement} />
          <TextField
            label="Zip Code"
            required
            fullWidth
            onChange={e => onMembershipChanged('address_zip', e.target.value, null, null)}
            autoComplete="postal-code"
            InputProps={{
              inputComponent: ZipCodeMask
            }}
            margin="normal"
            id="postalCode"
          />
        </div>
      }
    </div>
  );
};

export default Membership;
